import { Pipe, PipeTransform } from '@angular/core';
import { AlignmentType } from '@shared/enums/AlignmentType';

@Pipe({ name: 'alignment'})
export class AlignmentTypePipe implements PipeTransform {

  public transform(type: AlignmentType): string {
    let alignment = 'left';
    switch (type) {
      case AlignmentType.Left:
        alignment = 'left';
        break;
      case AlignmentType.Center:
        alignment = 'center';
        break;
      case AlignmentType.Right:
        alignment = 'right';
        break;
    }
    return alignment;
  }
}
